import { useEffect, useState } from 'react';

const useTitle = (docTitle) => {
	const [title, setTitle] = useState(docTitle);

	useEffect(() => {
		document.title = title;
	}, [title]);

	return [title, setTitle];
};

export { useTitle };
